import React from 'react';
import { AlertTriangle } from 'lucide-react';

const InvestmentDisclaimer = () => {
  return (
    <div
      className="rounded-2xl p-4 mb-4"
      style={{
        background: 'linear-gradient(to bottom right, #fff7ed, #fef3c7)',
        border: '1px solid #fed7aa'
      }}
    >
      <div className="flex items-center gap-1 mb-1">
        <AlertTriangle size={16} className="flex-shrink-0" style={{ color: '#f97316' }} />
        <h3 className="text-sm font-bold" style={{ color: '#7c2d12' }}>투자 유의사항</h3>
      </div>
      <p className="text-sm leading-relaxed" style={{ color: '#9a3412' }}>
        본 서비스의 정보는 참고용이며 투자 권유가 아닙니다. 모든 투자 결정과 손실 책임은 투자자 본인에게 있습니다.
        {/* 과거 수익률은 미래를 보장하지 않으며, 투자 전 충분한 검토를 권장합니다. */}
      </p>
    </div>
  );
};

export default InvestmentDisclaimer;